module.exports = __webpack_public_path__ + "media/images/logo/transparent_252x91-23b5e2cb0c839838f566e01130dd91b5.png";